const skillsData = {
	experienced: {
		title: {
			en: 'Experienced',
			de: 'Erfahren',
			pt: 'Experiente'
		},
		verb: {
			en: 'is',
			de: 'ist',
			pt: 'é'
		},
	},
	assertive: {
		title: {
			en: 'Assertive',
			de: 'Durchsetzungsfähig',
			pt: 'Assertivo(a)'
		},
		verb: {
			en: 'is',
			de: 'ist',
			pt: 'é'
		},
	},
	troubleshooter: {
		title: {
			en: 'Troubleshooter',
			de: 'Troubleshooter',
			pt: 'Resolvedor(a) de problemas'
		},
		verb: {
			en: 'is a',
			de: 'ist',
			pt: 'é um(a)'
		},
	},
	teamplayer: {
		title: {
			en: 'Teamplayer',
			de: 'Teamspieler',
			pt: 'Elemento de equipa'
		},
		verb: {
			en: 'is a',
			de: 'ist',
			pt: 'é um'
		},
	}
};

module.exports = {skillsData};